import { render, staticRenderFns } from "./Shippings.vue?vue&type=template&id=a6c5eb04&"
import script from "./Shippings.vue?vue&type=script&lang=js&"
export * from "./Shippings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports